import { render, staticRenderFns } from "./MisTakesList.vue?vue&type=template&id=28322ca4&scoped=true&"
import script from "./MisTakesList.vue?vue&type=script&lang=js&"
export * from "./MisTakesList.vue?vue&type=script&lang=js&"
import style0 from "./MisTakesList.vue?vue&type=style&index=0&id=28322ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28322ca4",
  null
  
)

component.options.__file = "MisTakesList.vue"
export default component.exports